<template>
    <v-menu
      v-model="menu"
      offset-y>
        <template v-slot:activator="{ on }">
            <template v-on="on"></template>
            <span
              style="display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; user-select: none"
              :style="{cursor: readonly ? null : 'pointer'}"
              @click.shift="if (!readonly && !menu) { toggle_training(); $emit('group_input', value.training) } else if (readonly) { $emit('readonly_fail') }"
              @click.exact="if (!readonly && !menu) { toggle_training() } else if (readonly) { $emit('readonly_fail') }"
              @click.right.exact="open_context_menu()"
              v-longpress="() => { if ($vuetify.breakpoint.mobile) { open_context_menu() } }"
              >
                <training-icon
                  school_state="no"
                  :training_state="value.training"
                  :dark="dark">
                </training-icon>
            </span>
        </template>
        <v-card
          flat
          style="text-align: center; overflow: hidden">
            <template v-for="(training_state, idx) in states.training">
                <div
                  v-if="training_state != value.training"
                  :key="idx"
                  @click.exact="set_training(training_state)"
                  @click.shift="set_training(training_state); $emit('group_input', training_state)"
                  class="py-5"
                  style="width:100%; cursor: pointer">
                    <training-icon
                      school_state="no"
                      :training_state="training_state"
                      :dark="dark">
                    </training-icon>
                </div>
            </template>
        </v-card>
    </v-menu>
</template>

<script>

import TrainingIcon from './TrainingIcon.vue'
import EventBus from './EventBus.js'


export default {
    name: 'TrainingCell',
    props: {
        dark: Boolean,
        value: {
            type: Object,
            default: () => ({
                school: 'no',
                training: 'no'
            })
        },
        readonly: Boolean
    },
    data: function () {
        return {
            menu: false,
            emitter: false,
            states: {
                school: ['no', 'normal', 'biweekly_0', 'biweekly_1'],
                // training: ['no', 'normal', 'morning'],
                training: ['no', 'normal'],
            }
        }
    },
    methods: {
        set_training: function(training_state) {
            this.$emit('input', {...this.value,
                                 training: training_state})
        },
        open_context_menu: function () {
            if (!this.readonly) {
                this.emitter = true
                EventBus.$emit('close_all')
            } else {
                this.$emit('readonly_fail')
            }
        },
        toggle_training: function () {
            if (this.value.training == 'no') {
                this.set_training('normal')
            } else {
                this.set_training('no')
            }
        },
    },
    mounted: function () {
        var self = this
        EventBus.$on('close_all', function () {
            if (!self.emitter) {
                self.menu = false
            } else {
                self.emitter = false
                self.menu = true
            }
        })
    },
    components: {
        TrainingIcon
    }
}

</script>
